import React, {Component} from "react";

class Reward extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="breadcrumb-area reward-widget">
                    <div>                    
                        <h3>Your Rewards</h3>

                        <div>
                            <div className="rounds-flex reward-child">
                                <div className="reward-icon">
                                    <img src="images/binance-bsc-yellow-logo.svg" />
                                </div>
                                <div>
                                    <h5>-</h5>
                                    <h5 className="sec-txt">BNB</h5>
                                </div>
                            </div>
                            <button>CLAIM REWARDS</button>
                        </div>
                    </div>
                    <div>                    
                        <h3>Staked</h3>

                        <div>
                            <div className="rounds-flex reward-child">
                                <div className="reward-icon">
                                    <img src="images/logo.png" />
                                    <img src="images/binance-bsc-yellow-logo.svg" /> 
                                </div>
                                <div>
                                    <h5>-</h5>
                                    <h5 className="sec-txt">Light-BNB LP</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>                    
                        <h3>Unstaked</h3>

                        <div>
                            <div className="rounds-flex reward-child">
                                <div className="reward-icon">
                                    <img src="images/logo.png" />
                                    <img src="images/binance-bsc-yellow-logo.svg" /> 
                                </div>
                                <div>
                                    <h5>-</h5>
                                    <h5 className="sec-txt">Light-BNB LP</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Reward;